import liveswitch from './libs/fm.liveswitch';

export default class LiveSwitchDeviceHelper{
    static getDevices(mode){
        if(mode === 'none'){
            const devices = {
                audio: null,
                video: null
            }

            return Promise.resolve(devices);
        }

        // Promise.all doesn't work properly with FM promises, have to wrap it in a promise
        return new Promise(function(resolve, reject){
            const deviceQueries = [];
            let audioDevices = null;
            let videoDevices = null;
            let needsPermission = false;

            const needsAudio = (mode === 'both' || mode === 'audio');
            const needsVideo = (mode === 'both' || mode === 'video');

            const localMedia = new liveswitch.LocalMedia(needsAudio, needsVideo);

            const audioDevicesQuery = localMedia.getAudioSourceInputs()
            .then(function(audioDevicesFound){
                audioDevices = audioDevicesFound;

                if(audioDevicesFound.length){
                    if(audioDevicesFound[0]._id === audioDevicesFound[0]._name){
                        needsPermission = true;
                    }
                }
            })
            .fail(function(error){
                reject(error);
            });

            deviceQueries.push(audioDevicesQuery);

            const videoDevicesQuery = localMedia.getVideoSourceInputs()
            .then(function(videoDevicesFound){
                videoDevices = videoDevicesFound;

                if(videoDevicesFound.length){
                    if(videoDevicesFound[0]._id === videoDevicesFound[0]._name){
                        needsPermission = true;
                    }
                }
            })
            .fail(function(error){
                reject(error);
            });

            deviceQueries.push(videoDevicesQuery);

            Promise.all(deviceQueries)
            .then(function(){
                if(!needsPermission){
                    const devices = {
                        audio: audioDevices,
                        video: videoDevices
                    }

                    resolve(devices);
                }
                else{
                    const deviceRequeries = [];

                    localMedia.start()
                    .then(function(){
                        const audioDevicesQuery = localMedia.getAudioSourceInputs()
                        .then(function(audioDevicesFound){
                            audioDevices = audioDevicesFound;
                        })

                        deviceRequeries.push(audioDevicesQuery);

                        const videoDevicesQuery = localMedia.getVideoSourceInputs()
                        .then(function(videoDevicesFound){
                            videoDevices = videoDevicesFound;
                        })

                        deviceRequeries.push(videoDevicesQuery);

                        Promise.all(deviceRequeries)
                        .then(function(){
                            const devices = {
                                audio: audioDevices,
                                video: videoDevices
                            }

                            localMedia.stop();
                            localMedia.destroy();

                            setTimeout(function(){
                                resolve(devices);
                            }, 1000);

                        })
                        .catch(function(error){
                            reject(error);
                        });
                    })
                    .fail(function(error){
                        reject(error);
                    });
                }
            })
            .catch(function(error){
                reject(error);
            });
        })
    }

    static getDeviceLists(mode){
        const _this = this;

        return new Promise(function(resolve, reject){
            _this.getDevices(mode)
            .then(function(devices){
                const deviceNames = {
                    audio: (devices.audio) ? devices.audio.map(device => device._name) : null,
                    video: (devices.video) ? devices.video.map(device => device._name) : null
                }

                resolve(deviceNames);
            })
            .catch(function(error){
                reject(error);
            });
        })
    }

    static getVideoResolution(localMedia){
        if(localMedia && typeof localMedia._getInternal()._getVideoMediaStream === 'function'){     // Doesn't work on scheiss IE
            const nativeVideoStream =  localMedia._getInternal()._getVideoMediaStream();

            if(nativeVideoStream){
                const nativeVideoTracks = nativeVideoStream.getVideoTracks();
                if(nativeVideoTracks && nativeVideoTracks.length){
                    const nativeVideoTrackSettings = nativeVideoTracks[0].getSettings();

                    return nativeVideoTrackSettings.width + 'x' + nativeVideoTrackSettings.height;
                }
            }
        }

        return null;
    }

    static getCurrentSettings(localMedia){
        return {
            cam: (localMedia && localMedia.getVideoSourceInput()) ? localMedia.getVideoSourceInput()._name : null,
            res: this.getVideoResolution(localMedia),
            mic: (localMedia && localMedia.getAudioSourceInput())? localMedia.getAudioSourceInput()._name : null,
            audioMuted: (localMedia) ? localMedia.getAudioMuted() : false,
            videoMuted: (localMedia) ? localMedia.getVideoMuted() : false
        }
    }
}